import { CURRENCY_CODE } from "./constants";
import itemDataTemplate from "./itemDataTemplate";

const ecommerceDataTemplate = itemData => {
  const { price } = itemData;
  const { currency, xrp, current } = price;

  const ecommerceData = {
    currency: CURRENCY_CODE,
    localCurrencyCode: currency,
    valueLocalCurrency: current?.value,
    items: [itemDataTemplate(itemData)]
  };

  ecommerceData.value = xrp?.value || undefined;

  return ecommerceData;
};

export default ecommerceDataTemplate;
